<h2 mat-dialog-title>Import Folders from Case</h2>
<mat-dialog-content>
  <form [formGroup]="importFoldersForm">
    <mat-form-field appearance="fill" style="width:100%">
      <mat-label>Case</mat-label>
      <mat-select formControlName="targetCaseId">
          <mat-option *ngFor="let lexbeCase of cases$ | async" [value]="lexbeCase.caseId">
            {{lexbeCase.caseName}}
          </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="submitAddEditFolderForm" [disabled]="!importFoldersForm.valid" (click)="save()">Import Folders</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
